import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ServiceTask } from "../core/model/serviceTask";
import { ServiceService } from "../core/service/service.service";

@Component({
  selector: "app-service-execution",
  templateUrl: "./service-execution.component.html",
  styleUrls: ["./service-execution.component.scss"],
})
export class ServiceExecutionComponent implements OnInit {
  services: ServiceTask[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _serviceService: ServiceService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getServices();
  }

  getServices() {
    this._serviceService.getAllServices().subscribe(
      (data) => {
        this.services = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
